module.exports = __webpack_public_path__ + "img/qr6.f2b80eb9.png";